import { Controller } from "@hotwired/stimulus";

// Retire l'ossature de chargement dès que l'image est peinte.
//
// Posé sur le conteneur qui porte `.g4s-skeleton`. Sans cela, le balayage
// tournerait indéfiniment derrière une image opaque.
export default class extends Controller {
  static classes = ["skeleton"];

  connect() {
    this.images = Array.from(this.element.querySelectorAll("img"));
    if (this.images.length === 0) return this.clear();

    // Une image déjà en cache ne déclenche pas `load`.
    if (this.images.every((image) => image.complete && image.naturalWidth > 0)) {
      return this.clear();
    }

    this.onSettled = this.settle.bind(this);
    this.images.forEach((image) => {
      image.addEventListener("load", this.onSettled);
      // Une image cassée doit elle aussi rendre la main, sinon le balayage
      // laisse croire à un chargement éternel.
      image.addEventListener("error", this.onSettled);
    });
  }

  disconnect() {
    if (!this.onSettled) return;
    this.images.forEach((image) => {
      image.removeEventListener("load", this.onSettled);
      image.removeEventListener("error", this.onSettled);
    });
  }

  settle() {
    const done = this.images.every((image) => image.complete);
    if (done) this.clear();
  }

  clear() {
    this.element.classList.remove("g4s-skeleton", "g4s-skeleton--dark");
  }
}
